import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import { Box, IconButton, Stack } from '@mui/material';
import { useLocation } from 'react-router';
import { useSearchNavigation } from '../../../../hooks/useSearchNavigation';
import AccountMenuRenderer from './AccountMenuRenderer';
import BalanceDepositControl from './BalanceDepositControl';
import DesktopHeaderFrame from './DesktopHeaderFrame';
import HeaderHomeLink from './HeaderHomeLink';
import { styles } from './Header.styles';
import NotificationButton from './NotificationButton';

type DesktopAuthenticatedToolbarProps = {
  isSidebarCompact: boolean;
  showSidebarCollapse: boolean;
  showSearchEntry: boolean;
  toggleSidebarCompact?: () => void;
};

export const DesktopAuthenticatedToolbar = ({
  isSidebarCompact,
  showSidebarCollapse,
  showSearchEntry,
  toggleSidebarCompact,
}: DesktopAuthenticatedToolbarProps) => {
  const { pathname } = useLocation();
  const { handleSearchClick } = useSearchNavigation();

  return (
    <DesktopHeaderFrame
      contentTestId='neobet-desktop-content-container'
      isSidebarCompact={isSidebarCompact}
      showSidebarCollapse={showSidebarCollapse}
      sidebarSlotTestId='neobet-desktop-sidebar-slot'
      testId='neobet-desktop-utility-bar'
      toggleSidebarCompact={toggleSidebarCompact}
    >
      <HeaderHomeLink />
      <Box sx={styles.spacer} />
      <Stack direction='row' sx={styles.utilityCluster}>
        <BalanceDepositControl />

        {showSearchEntry ? (
          <IconButton
            data-testid='neobet-search-button'
            sx={styles.utilityIconButton(pathname.startsWith('/search'))}
            onClick={handleSearchClick}
          >
            <SearchRoundedIcon fontSize='small' />
          </IconButton>
        ) : null}

        <NotificationButton />
        <Box data-testid='neobet-account-trigger'>
          <AccountMenuRenderer />
        </Box>
      </Stack>
    </DesktopHeaderFrame>
  );
};

export const MobileAuthenticatedToolbar = () => {
  return (
    <Box sx={styles.mobileTopBar} data-testid='neobet-mobile-topbar'>
      <HeaderHomeLink size='small' />

      <Stack direction='row' sx={styles.mobileActions}>
        <BalanceDepositControl />
        <Box data-testid='neobet-account-trigger'>
          <AccountMenuRenderer showUnreadBadge />
        </Box>
      </Stack>
    </Box>
  );
};
